import { Theme } from './theme.interface';
import { Contrast } from './contrast.theme';

export const BlueOnBlack: Theme = {
	...Contrast, // Inherit parent contrast theme colours, spinner, blacks and whites etc.
    name: 'BlueOnBlack',
	properties: (() => { 
		const primary = '#000';
		const secondary = '#333';
		const tertiary = '#ddd'

		const foreground = '#B2DAFF';

		return {
			...Contrast.properties,

			// Primary colours
			...Object.fromEntries(
				['--background-secondary', '--background-tertiary', '--background-quaternary', '--or-background', '--preview-one']
					.map(key => [key, primary])
			),

			// Secondary colours
			...Object.fromEntries(
				[
					'--background-default',
					'--button-primary-background',
					'--button-secondary-background',
					'--button-accent-background',
					'--loading-background',
					'--dialog-background',
					'--mca-background',
				].map(key => [key, secondary])
			),

			// Tertiary Colours
			...Object.fromEntries(
				[
					'--button-primary-background-disabled',
					'--button-secondary-background-disabled',
				].map(key => [key, tertiary])
			),

			...Object.fromEntries(
				[
					'--foreground-default',
					'--foreground-secondary',
					'--foreground-tertiary',
					'--foreground-quaternary',
					'--button-primary-foreground',
					'--button-secondary-foreground',
					'--button-secondary-foreground-disabled',
					'--or-foreground',
					'--progress-color',
					'--mca-foreground',
					'--preview-two'
				].map(key => [key, foreground])
			),
		};
		})(),
    canSelect: true
};
